import React from 'react';
import styles from './Hamburger.module.scss';

const Hamburger = () => {
	return <span className={styles.hamburger}>❖</span>;
};

export default Hamburger;
